export default {
  googleAnalyticsMeasurementId: 'G-6NE7MBSF9K'
}
